export const SIZE_OPTIONS = [
  "1–10 employees",
  "11–50 employees",
  "51–200 employees",
  "201–500 employees",
  "501–1,000 employees",
  "1,001–5,000 employees",
  "5,000+ employees",
] as const

export const SIZE_PLACEHOLDER = "Choose a range"

export const CUSTOMER_BLURB = "Set once. Every session inherits it."
export const NEW_SESSION_BLURB =
  "Name it now so the session list and the leave-behind read cleanly. Rounds and timings are set in the lobby."

export const ABOUT_LABEL = "What does the business do?"
export const ABOUT_PLACEHOLDER =
  "One or two lines. Enough that the leave-behind reads like it was written for them."

export const UNTITLED_SESSION = "Untitled session"

/** What a session row says about itself, from `session.status`. */
export const SESSION_STATUS_LABEL = {
  pending: "Waiting to start",
  active: "In progress",
  completed: "Complete",
} as const

/** Shown instead of the status when the link has timed out. */
export const SESSION_EXPIRED_LABEL = "Expired"

/*
 * What a finished session row offers, where a running one shows its progress.
 * Opening a completed session lands on the leave-behind, which is the only
 * reason anyone comes back to one.
 */
export const OPEN_REPORT = "Open the report"
